import { Clock, CheckCircle2, XCircle, Ban, Hourglass, CalendarCheck } from "lucide-react";

// Single source of truth for booking status display across customer/cleaner/admin.
export const STATUS_META = {
  awaiting_payment: { label: "Awaiting payment", cls: "bg-amber-100 text-amber-700", icon: Hourglass },
  pending: { label: "Requested", cls: "bg-blue-100 text-blue-700", icon: Clock },
  confirmed: { label: "Confirmed", cls: "bg-green-100 text-green-700", icon: CalendarCheck },
  awaiting_approval: { label: "Awaiting your approval", cls: "bg-violet-100 text-violet-700", icon: Hourglass },
  completed: { label: "Completed", cls: "bg-emerald-100 text-emerald-700", icon: CheckCircle2 },
  cancelled: { label: "Cancelled", cls: "bg-red-100 text-red-700", icon: Ban },
  declined: { label: "Declined", cls: "bg-red-100 text-red-700", icon: XCircle },
};

export default function BookingStatusBadge({ status, size = "sm" }) {
  const m = STATUS_META[status] || { label: status, cls: "bg-secondary text-foreground", icon: Clock };
  const Icon = m.icon;
  const pad = size === "sm" ? "text-xs px-2.5 py-0.5" : "text-sm px-3 py-1";
  return (
    <span className={`inline-flex items-center gap-1 rounded-full font-medium ${pad} ${m.cls}`} data-testid={`status-${status}`}>
      <Icon className="h-3.5 w-3.5" /> {m.label}
    </span>
  );
}
